import React from 'react';

export default function News() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-tealLight/30 to-paper text-ink antialiased selection:bg-teal/20 selection:text-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 font-sans">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-tealLight border border-teal/20 text-teal text-xs font-semibold uppercase tracking-wider">
              News & Updates
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-sans font-bold leading-tight tracking-tight text-center text-teal">
            News & Updates
          </h1>

          <p className="mt-6 text-lg sm:text-xl text-inkSoft max-w-3xl mx-auto leading-relaxed text-center">
            Updates and announcements from Diagnostic Intelligence.
          </p>
        </div>

        {/* Current Status */}
        <div className="max-w-3xl mx-auto text-center">
          <div className="bg-white border border-rule rounded-xl p-8 shadow-[4px_4px_0_0_rgba(20,184,166,0.18)]">
            <div className="text-4xl mb-4">📰</div>

            <h2 className="text-xl font-bold text-ink mb-3">
              No Public Announcements at This Time
            </h2>

            <p className="text-sm sm:text-base text-inkSoft leading-relaxed">
              As of today, there are no public announcements or news updates
              available on this page. Announcements will be published here as
              information becomes publicly available.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
